// frontend/src/services/supabase.ts
import { createClient } from "@supabase/supabase-js";

const configuredUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

/**
 * Local Supabase is at 127.0.0.1:54321. When the SPA is opened via a Cursor
 * Cloud HTTPS proxy (*.cursorvm.com, *.agent.cvm.dev, …), the browser cannot
 * call that HTTP URL (mixed content / wrong localhost). Use the page origin
 * instead and let the Vite dev-server proxy forward to local Supabase.
 */
function isCursorCloudPreviewHost(host: string): boolean {
  return (
    host.endsWith(".cursorvm.com") ||
    host.endsWith(".cvm.dev") ||
    host.endsWith(".cursor.com")
  );
}

function resolveSupabaseUrl(): string {
  if (typeof window !== "undefined") {
    if (isCursorCloudPreviewHost(window.location.hostname)) {
      return window.location.origin;
    }
  }
  if (!configuredUrl) {
    throw new Error("Missing VITE_SUPABASE_URL");
  }
  return configuredUrl;
}

const supabaseUrl = resolveSupabaseUrl();

if (!supabaseUrl || !supabaseKey) {
  throw new Error("Missing Supabase environment variables");
}

// Configure the client with options for local development
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
  },
  // For local development, ensure the functions URL is correctly set
  // This will default to production URL when not in local development
  // global: {
  //   headers: {
  //     Authorization: `Bearer ${supabaseKey}`,
  //   },
  // },
});
